

<nrk-window #profitCalc *ngIf="type === marginType.cs && withWindow">
  <nrk-header><b>CS Profit Margin</b></nrk-header>
  <nrk-content>
    <ng-container *ngTemplateOutlet="profitTpl;"></ng-container>
  </nrk-content>
</nrk-window>

<ng-container *ngIf="type === marginType.cs && !withWindow">
      <ng-container *ngTemplateOutlet="profitTpl;"></ng-container>
</ng-container>

<ng-template #profitTpl>
    <div class="profit-calc">
      <div *ngIf="withWindow">
        <span style="width:3rem">Import Duty: <ngx-doc-form-texfield [styles]="{width: '3rem'}" [(value)]="importDuty"></ngx-doc-form-texfield> %</span>
        <span style="width:3rem">Other Costs: <ngx-doc-form-texfield [styles]="{width: '3rem'}" [(value)]="otherCosts"></ngx-doc-form-texfield> %</span>
        <button class="nrk-button" (click)="calcProfitMarginData()">Recalculate</button>
        <button class="nrk-button" (click)="downloadProfitCalcPdf()">PDF</button>
        <button class="nrk-button" (click)="downloadProfitCalcXls()">XLS</button>
        <button class="ml-4 nrk-button" (click)="closeGS()">{{ compilation?.csCompleted ? 'Reopen GS' : 'Close GS' }}</button>
      </div>
      <div #profitCalcTable>
        <table>
          <tr>
            <th>Recipient</th><th>SPO</th><th>Customer</th><th>Product</th><th style="text-align:right">Purchase EUR</th><th style="text-align:right">Sale EUR</th><th>% Markup</th>
          </tr>
          <tr *ngFor="let item of profitMarginData.shipmentLineItems">
            <td>{{item.recipient}}</td>
            <td>{{item.code}}</td>
            <td>{{item.customer}}</td>
            <td>{{item.product}}</td>
            <td style="text-align:right">{{item.buyingNet | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}</td>
            <td style="text-align:right">{{item.sellingNet| currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
            <td style="text-align:right">{{item.percent | percent : '1.1-1' : 'de'}}</td>
          </tr>
          <tr>
            <td colspan="4" style="font-weight:bold">CS Total NET</td>
            <td style="text-align:right;font-weight:bold">{{profitMarginData.buyingSum | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
            <td style="text-align:right;font-weight:bold">{{profitMarginData.salesSum | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
            <td></td>
          </tr>
          <tr><td style="border: none; height: 1rem; padding:0">&nbsp;</td></tr>
          <tr>
            <td colspan="4">CS Purchasing Sum</td>
            <td colspan="2" style="text-align:right">- {{profitMarginData.buyingSum | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
            <td></td>
          </tr>
          <tr>
            <!-- <td colspan="4">Supplier IN Sum</td> -->
            <td colspan="4">Transport &amp; Handling</td>
            <td colspan="2" style="text-align:right">- {{profitMarginData.supplierInvoiceSum | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
            <td></td>
          </tr>
          <tr>
            <td colspan="4">Import Duty {{importDuty}}%</td>
            <td colspan="2" style="text-align:right">- {{profitMarginData.importDuty | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
            <td></td>
          </tr>
          <tr>
            <!-- <td colspan="4">Other Costs</td> -->
            <td colspan="4">Statistical {{otherCosts}}% on (CS Purchasing + Supplier IN Sum + Import) for local transport</td>
            <td colspan="2" style="text-align:right">- {{profitMarginData.otherCosts | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
            <td></td>
          </tr>
          <tr><td style="border: none; height: 1rem; padding:0">&nbsp;</td></tr>
          <tr>
            <td colspan="4" style="font-weight:bold">Profit Margin</td>
            <td colspan="2" style="text-align:right;font-weight:bold">{{profitMarginData.sum | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
            <td></td>
          </tr>
          <tr>
              <!-- (=Profit maring in EUR / sum of sales price in EUR) -->
            <td colspan="4" style="font-weight:bold">Profit Margin %</td>
            <td colspan="2" style="text-align:right;font-weight:bold">{{profitMarginData.percentTotal | percent : '1.2-2' : 'de'}}</td>
            <td></td>
          </tr>
          <tr>
            <td colspan="4" style="font-weight:bold">Total Net Weight (kg)</td>
            <td colspan="2" style="text-align:right;font-weight:bold">{{profitMarginData.totalNetWeight | number : '1.2-2' : 'de'}} kg</td>
            <td></td>
          </tr>
        </table>
      </div>
    </div>
</ng-template>






<nrk-window #profitOCSPO *ngIf="type === marginType.ocSpo && withWindow">
  <nrk-header><b>OC to SPO Profit Margin</b></nrk-header>
  <nrk-content>
      <ng-container *ngTemplateOutlet="ocToSpoTpl;"></ng-container>
  </nrk-content>
</nrk-window>

<ng-container *ngIf="type === marginType.ocSpo && !withWindow">
      <ng-container *ngTemplateOutlet="ocToSpoTpl;"></ng-container>
</ng-container>

<ng-template #ocToSpoTpl>
    <div *ngIf="withWindow" style="display:flex;align-items:center;justify-content:center" class="m-2">
      <button class="nrk-button" (click)="downloadProfitCalcPdf(true)">PDF (OC)</button>
      <div>
        <input class="ml-3" type="checkbox" [(ngModel)]="withMarkup" /> with markup
        <input class="ml-2" type="checkbox" [(ngModel)]="partiallyAssigned" (ngModelChange)="calcOcSpoProfitMarginData()" /> consider partially assigned
      </div>
      <button *ngIf="!compilation?.projectCompleted" class="nrk-button ml-3" (click)="finalizeProject()">Finalize Project (remove from project list)</button>
      <button *ngIf="compilation?.projectCompleted" class="nrk-button ml-3" (click)="finalizeProject(false)">Revert Project Finalization</button>
    </div>
    <div #profitCSSPOTable class="profit-margin" style="padding: 1rem; min-width:50rem">
      <ng-container *ngIf="compilation">
        <div style="font-weight: bold; font-size:1.4rem;">
          <div style="position:relative; text-align:left" *ngIf="ocSpoProfitData.projectStatus">
            <div style="position:absolute;left:0;border: 1px solid gray;padding:0.25rem;background-color:white">
              {{ocSpoProfitData.projectStatus}}
              <div *ngIf="withChecklist" style="font-size:0.9rem;">Project manually closed<br>{{moment().format('YYYY-MM-DD') }} by {{auth.user.short}}</div>
            </div>
          </div>
          <div style="position:relative; text-align:right" *ngIf="getFiscalYear()">
            <span style="position:absolute;right:0;border: 1px solid gray;padding:0.25rem">{{getFiscalYear()}}</span>
          </div>
          <div style="text-align:center;">Project Overview ({{compilation.code}})</div>
          <div style="margin-top:1.5rem;text-align:center"><span class="layout-label">Base Product:</span> <span>{{compilation.lineItems?.[0]?.finishedProduct?.product?.name}}</span></div>
        </div>

        <div class="info-segment-new">
          <ul>
            <li>
              <div class="section-header">Customer Reference</div>
              <table class="gap-top">
                <tr *ngIf="compilation.customerName">
                  <td><span class="label">Name:</span></td>
                  <td><span>{{data.getBusinessName(compilation.customerReference)}}</span></td>
                </tr>
                <tr *ngIf="compilation.customerDocumentNumber">
                  <td><span class="label">PO&nbsp;Number:</span></td>
                  <td><span>{{compilation.customerDocumentNumber}}</span></td>
                </tr>
                <tr *ngIf="compilation.customerDocumentDate">
                  <td><span class="label">PO&nbsp;Date:</span></td>
                  <td><span>{{compilation.customerDocumentDate | date : 'yyyy-MM-dd'}}</span></td>
                </tr>
                <tr *ngIf="compilation.rfqReference">
                  <td><span class="label">RFQ Ref:</span></td>
                  <td><span>{{compilation.rfqReference}}</span></td>
                </tr>
                <tr *ngIf="compilation.rfqDate">
                  <td><span class="label">RFQ Date:</span></td>
                  <td><span>{{compilation.rfqDate | date : 'yyyy-MM-dd'}}</span></td>
                </tr>
                <tr *ngIf="linkedFC?.customerDocumentNumber">
                  <td><span class="label">Frame&nbsp;Contract:</span></td>
                  <td><span>{{linkedFC?.customerDocumentNumber}}</span></td>
                </tr>
                <tr *ngIf="linkedFC?.customerDocumentDate">
                  <td><span class="label">FC&nbsp;Date:</span></td>
                  <td><span>{{linkedFC?.customerDocumentDate | date : 'yyyy-MM-dd'}}</span></td>
                </tr>
              </table>
            </li>

            <li><ng-container *ngIf="linkedOF?.nameOverride || linkedOF?.code || linkedPfspos?.length || linkedCsSpoCodes || compilation.issueDate">
              <div class="section-header">Nippon Rika Reference</div>
              <table class="gap-top">
                <tr *ngIf="linkedOF?.nameOverride || linkedOF?.code">
                  <td><span class="label">Quotation&nbsp;Ref:</span></td>
                  <td><span>{{linkedOF?.nameOverride || linkedOF?.code}}</span></td>
                </tr>
                <tr *ngIf="linkedCsSpoCodes?.length">
                  <td><span class="label">Docs:</span></td>
                  <td class="textbox">{{linkedCsSpoCodes.join('\n')}}</td>
                </tr>
                <tr *ngIf="compilation.issueDate">
                  <td><span class="label">Date of Doc:</span></td>
                  <td class="textbox">{{compilation.issueDate | date : 'yyyy-MM-dd'}}</td>
                </tr>
              </table>
            </ng-container></li>

            <li><ng-container *ngIf="compilation.manufacturerRecipient || compilation.manufacturerRecipient || compilation.internal || compilation.machineSN">
              <div class="section-header">Manufacturer Reference</div>
              <table class="gap-top">
                <tr *ngIf="compilation.manufacturerRecipient">
                  <td><span class="label">Company:</span></td>
                  <td><span>{{data.getBusinessName(compilation.manufacturerRecipient)}}</span></td>
                </tr>
                <tr *ngIf="compilation.internal">
                  <td><span class="label">Project Number:</span></td>
                  <td><span>{{compilation.internal}}</span></td>
                </tr>
                <tr *ngIf="compilation.machineSN">
                  <td><span class="label">Machine S/N:</span></td>
                  <td><span class="textbox">{{compilation.machineSN}}</span></td>
                </tr>
              </table>
            </ng-container></li>
          </ul>
        </div>

        <table class="profit-layout-table" style="margin-top:1rem">
          <tr>
            <ng-container *ngFor="let date of paymentDates">
              <td *ngIf="date.id && compilation[date.id]">{{date.name}}</td>
            </ng-container>
          <tr>
            <ng-container *ngFor="let date of paymentDates">
              <td *ngIf="date.id && compilation[date.id]">{{compilation[date.id] |  date : 'yyyy-MM-dd'}}</td>
            </ng-container>
          </tr>
        </table>

        <div style="margin-top:1rem">
          <span class="layout-label">Next Invoice Date:</span> <span>{{compilation.expectedNextInvoiceDate| date : 'yyyy-MM-dd'}}</span>
          <span *ngIf="ocSpoProfitData.nextInvoiceMilestone" class="layout-label" style="padding-left:2rem">Next Invoice Milestone:</span> <span>{{ocSpoProfitData.nextInvoiceMilestone}}</span>
        </div>

        <div style="margin-top:1rem" *ngIf="!print">
          <div class="layout-label">Remarks:</div>
          <!-- <ngx-form-text [(value)]="compilation.profitMarginText" [multiline]="1"></ngx-form-text> -->
          <ngx-profit-margin-remark [compilation]="compilation" [print]="print"></ngx-profit-margin-remark>
          <button *ngIf="compilation.projectRemark?.items?.length" class="nrk-button" (click)="saveProfitMarginText()">Save Remarks</button>
        </div>
        <div style="margin-top:1rem" *ngIf="print && compilation.projectRemark?.items?.length && compilation.projectRemark?.inProjectOverview">
          <table>
            <tr  *ngFor="let item of compilation.projectRemark.items">
              <td style="padding-right:0.5rem">{{item.date | date : 'yyMMdd'}}</td>
              <td style="padding-right:0.5rem">({{item.user}})</td>
              <td style="width: 100%">{{item.text}}</td>
            </tr>
          </table>
        </div>

        <div style="margin-top:2rem"><b>OC to SPO</b></div>

        <div class="profit-calc" style="padding:0.5rem 0;margin-bottom:0.2rem;">
          <table style="width: 100%; padding: 0; margin: 0">
            <tr>
              <th colspan="5" style="text-align:left">{{ocSpoProfitData.oc}}</th>
              <th *ngIf="withMarkup" colspan="5" style="text-align:left">{{ocSpoProfitData.spo}}</th></tr>
            <tr>
              <td colspan="4">OC Total Net</td>
              <td style="text-align:right;">{{ocSpoProfitData.ocTotal | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}</td>
              <td *ngIf="withMarkup" colspan="3" style="border-left: 4px double #ddd;">SPO Total Net</td>
              <td *ngIf="withMarkup" style="text-align:right">{{ocSpoProfitData.spoTotal | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
            </tr>
            <tr *ngFor="let payment of ocSpoProfitData.payments" style="color:gray">
              <td>{{payment?.oc.text}}</td>
              <td>{{payment?.oc.payment}}</td>
              <td>{{payment?.oc.date}}</td>
              <td [style]="payment.ocStatus.style">{{payment.ocStatus.text}}</td>
              <td style="text-align:right;">{{payment?.oc.value | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
              <td *ngIf="withMarkup" style="border-left: 4px double #ddd;">{{payment?.spo.text}}</td>
              <td *ngIf="withMarkup">{{payment?.spo.date}}</td>
              <td *ngIf="withMarkup">{{payment?.spo?.date ? 'paid' : ''}}</td>
              <td *ngIf="withMarkup" style="text-align:right">{{-payment?.spo.value | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
            </tr>
            <tr>
              <td colspan="4">Sum Payment</td>
              <td style="text-align:right;">{{-ocSpoProfitData.sumOc | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
              <td *ngIf="withMarkup" style="border-left: 4px double #ddd;" colspan="3">Supplier INV Sum Net</td>
              <td *ngIf="withMarkup" style="text-align:right">{{-ocSpoProfitData.sumSpo | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
            </tr>
            <tr>
              <td colspan="4"><b>OC Remaining Net</b></td>
              <td style="text-align:right;"><b>{{ocSpoProfitData.remainingOc | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</b></td>
              <td *ngIf="withMarkup" style="border-left: 4px double #ddd;" colspan="3"><b>Remaining SPO Value</b></td>
              <td *ngIf="withMarkup" style="text-align:right"><b>{{ocSpoProfitData.remainingSpo | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</b></td>
            </tr>
            <ng-container *ngIf="withMarkup">
              <tr><td [attr.colspan]="withMarkup ? 8 : 5"></td></tr>
              <tr><td [attr.colspan]="withMarkup ? 8 : 5">Expected Project Markup</td><td style="text-align:right">{{ocSpoProfitData.expectedMarkup | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td></tr>
              <tr style="color: gray"><td [attr.colspan]="withMarkup ? 8 : 5">Expected Project Profit Margin in %</td><td style="text-align:right">{{(ocSpoProfitData.expectedMarkupPercent ?? 0) | percent}}</td></tr>
              <tr><td [attr.colspan]="withMarkup ? 8 : 5">Current Project Markup</td><td style="text-align:right">{{ocSpoProfitData.currentMarkup | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td></tr>
              <tr style="color: gray"><td [attr.colspan]="withMarkup ? 8 : 5">Current Project Profit Margin in %</td><td style="text-align:right">{{(ocSpoProfitData.currentMarkupPercent ?? 0) | percent}}</td></tr>
            </ng-container>
          </table>
        </div>

        <div *ngIf="this.compilation.paymentPlan?.items?.length" class="mb-4"><br>Payment Plan OC
          <ngx-payment-plan [compilation]="this.compilation" [print]="true" [profitMargin]="true"></ngx-payment-plan>
        </div>

        <ng-container *ngIf="this.linkedPfspos?.[0]?.paymentPlan?.items?.length && withMarkup">Payment Plan SPO
          <ngx-payment-plan [compilation]="linkedPfspos?.[0]" [print]="true" [profitMargin]="true"></ngx-payment-plan>
        </ng-container>

        <!-- <div style="margin-top:1.5rem"><b>Project Status</b></div>

        <div style="margin-top:0.5rem">{{ocSpoProfitData.projectStatus}}</div> -->

        <div class="mt-4 checklist" style="page-break-before:always" *ngIf="withChecklist">
          <h4>Machinery Project Closing Checklist</h4>
          <table>
            <thead>
              <tr>
                <th>SC</th>
                <th>HC</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr><td>☐</td><td>☐</td><td>Cover sheet</td></tr>
              <tr><td>☐</td><td>☐</td><td>Liste der IN (also alle gelisteten IN)</td></tr>
              <tr><td>☐</td><td>☐</td><td>Liste SPIN (alle SPIN)</td></tr>
              <tr><td>☐</td><td>☐</td><td>Last Quote</td></tr>
              <tr><td>☐</td><td>☐</td><td>PO with all documents</td></tr>
              <tr><td>☐</td><td>☐</td><td>BG (if applicable)</td></tr>
              <tr><td>☐</td><td>☐</td><td>FAT documents</td></tr>
              <tr><td>☐</td><td>☐</td><td>SAT documents</td></tr>
              <tr><td>☐</td><td>☐</td><td>Shipping documents</td></tr>
              <tr><td>☐</td><td>☐</td><td>Tax hint documentation</td></tr>
            </tbody>
          </table>
        </div>
      </ng-container>
    </div>
</ng-template>    
